import React, { useEffect, useState } from "react";
import { config } from '../../config/env';

const SearchFilterBar = ({ onSearchChange, onFilterChange }) => {
  const [topics, setTopics] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [selectedTopic, setSelectedTopic] = useState("");

  useEffect(() => {
    const fetchTopics = async () => {
      try {
        const res = await fetch(`${config.apiBaseUrl}/api/v1/topics/`);
        const data = await res.json();
        setTopics(data.data || []);
      } catch (err) {
        console.error("Error fetching topics:", err);
      }
    };
    fetchTopics();
  }, []);

  const handleSearchSubmit = () => {
    onSearchChange(searchInput.trim());
  };

  const handleKeyDown = (enter) => {
    if (enter.key === "Enter") {
      handleSearchSubmit();
    }
  };

  const handleTopicChange = (e) => {
    const value = e.target.value;
    setSelectedTopic(value);
    onFilterChange(value);
  };

  const handleResetFilters = () => {
    setSearchInput("");
    setSelectedTopic("");
    onSearchChange("");
    onFilterChange("");
  };

  return (
    <div className="w-full px-6 pt-10 bg-white">
      <div className="flex flex-col gap-6 w-full">
        {/* Search Bar */}
        <div className="flex items-center gap-3 mb-2 border-b-2 border-black pb-2">
          <button
            onClick={handleSearchSubmit}
            className="text-black hover:text-gray-700 focus:outline-none"
          >
            <svg className="w-9 h-9" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-4.35-4.35M10 18a8 8 0 100-16 8 8 0 000 16z" />
            </svg>
          </button>
          <input
            type="text"
            placeholder="Search"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            onKeyDown={handleKeyDown}
            className="text-2xl font-semibold text-black border-none bg-transparent focus:outline-none placeholder-gray-400 w-full"
          />
        </div>

        <div className="flex items-center gap-4 flex-wrap mt-2">
          <p className="text-xl font-bold text-gray-800">Filter by:</p>
          <div className="relative w-56 bg-white border border-gray-400 shadow-sm rounded-full">
            <select
              className="appearance-none w-full px-4 py-2 pr-8 text-sm bg-transparent focus:outline-none focus:ring-1 focus:ring-black rounded-full"
              value={selectedTopic}
              onChange={handleTopicChange}
            >
              <option value="">Topic</option>
              {topics.map((topic) => (
                <option key={topic.id} value={topic.id}>
                  {topic.name}
                </option>
              ))}
            </select>
            <div className="pointer-events-none absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-600">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>

          <button
            onClick={handleResetFilters}
            className="px-4 py-2 text-sm border border-gray-400 text-gray-700 hover:bg-gray-100 rounded-full"
          >
            Clear
          </button>
        </div>
      </div>

      <hr className="mt-10 mb-14 border-t-2 border-gray-500 w-full" />
    </div>
  );
};

export default SearchFilterBar;
